import React from "react";

class BodyOfHome extends React.Component {
  render() {
    return (
      <div className="home">
        <div className="row mx-0">
          <div className="col-12 col-xl-6 d-block d-xl-none text-center mt-5">
            <img src="/mainSecMob.svg" width="100%" alt="" />
          </div>
          <div className="col-12 col-xl-6 mainSecLeft">
            <h1>
              Let's <br /> achieve excellence <br /> together
            </h1>
            <p>
              Lesen macht Spaß!
            </p>

            <div className="links">
              <a >
                <img src="/youtube.svg" alt="" />
              </a>
              <a >
                <img src="/twitter.svg" alt="" />
              </a>
              <a >
                <img src="/insta.svg" alt="" />
              </a>
              <a href="https://www.facebook.com/deutschmansoura" target="_blank">
                <img src="/Facebook.svg" alt="" />
              </a>
            </div>
          </div>
          <div className="col-6 mainSecRight d-none d-xl-block">
            {/*<img src="/mainSecWeb.svg"/>*/}
          </div>
          <div className="row mx-0 text-center copyRight">
            <div className="col-12">
              <p>Copyright © Depax 2021. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BodyOfHome;
